(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/hooks/use-all-exclusions.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/hooks/use-all-exclusions.js');
'use strict';

const useAllExclusions = activeExclusions => {
  const allGames = activeExclusions === null || activeExclusions === void 0 ? void 0 : activeExclusions.find(exclusion => exclusion.subSystem === 'Alla spel');
  const allGamesExpiry = Date.parse(allGames === null || allGames === void 0 ? void 0 : allGames.expiry);
  return allGamesExpiry;
};
svs.selfExclusion.useAllExclusions = useAllExclusions;

 })(window);